import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";

import i18n from "../../../translations/i18n";
import { withExpositions } from "../../../hocs/entities/withExpositions";
import {
  makeExpositionPreviewsSelector,
  makeExpositionPreviewsAnyKeySelector,
  makeExpositionPreviewsFetchStatusSelector,
} from "../../../selectors/expositionPreviews";
import { EXPOSITION_SHAPE, EXPOSITION_KIND_PAST } from "../../../constants/expositionConstants";
import { COLLECTION_FETCH_STATUS_SHAPE } from "../../../selectors/collections";
import Pagination from "../../../components/layout/pagination";
import Item from "../../../components/expositions/item";


class Past extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchExpositions(EXPOSITION_KIND_PAST, 1, 100);
  }

  handlePageChange = (page) => {
    if (event) {
      event.preventDefault();
    }
    this.props.fetchExpositions(EXPOSITION_KIND_PAST, page, 100);
  }

  handleFavorite = () => {
    const { pagination, fetchExpositions } = this.props;

    fetchExpositions(EXPOSITION_KIND_PAST, pagination.current_page);
  }

  render() {
    const { expositions, pagination, fetchStatus } = this.props;

    const expositionsPresent = expositions && expositions.length > 0;
    if (!expositionsPresent) {
      return null;
    }

    return (
      <div className="p-exhibitions__list">
        <div className="p-exhibitions__title">
          {i18n.t('pages.expositions.past.title')}
        </div>

        <div className="p-exhibitions__list-inner">
          {(expositions || []).map((item) =>
            <Item
              className="p-exhibitions__list-item __past"
              key={item.id}
              item={item}
              withLink={false}
            />
          )}
        </div>

        <Pagination
          className="p-exhibitions__pagination"
          totalPages={pagination.total_pages || 1}
          disabled={fetchStatus.isFetching}
          onChange={this.handlePageChange}
          fetchOnMount={false}
        />
      </div>
    );
  }
}

Past.propTypes = {
  expositions: PropTypes.arrayOf(PropTypes.shape(EXPOSITION_SHAPE)),
  fetchStatus: PropTypes.shape(COLLECTION_FETCH_STATUS_SHAPE).isRequired,
};

const expositionsSelector = makeExpositionPreviewsSelector('past');
const expositionsPaginationSelector = makeExpositionPreviewsAnyKeySelector('pagination');
const expositionsFetchStatusSelector = makeExpositionPreviewsFetchStatusSelector();

function mapStateToProps(state) {
  return {
    expositions: expositionsSelector(state),
    pagination: expositionsPaginationSelector(state) || {},
    fetchStatus: expositionsFetchStatusSelector(state),
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
  }, dispatch)
}

export default compose(
  withExpositions,
  connect(mapStateToProps, mapDispatchToProps)
)(Past)
